import React, { useEffect } from "react";
import {
  useTable,
  useSortBy,
  useRowSelect,
  useResizeColumns,
  useFlexLayout,
} from "react-table";

const DataTable = ({ title, columns, data, onSelectRow }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleRowSelected,
    state: { selectedRowIds },
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
      // Override toggleRowSelected to ensure single selection only
      toggleRowSelected: (rowId, value) => {
        // Deselect all rows except the currently selected one
        Object.keys(selectedRowIds).forEach((id) => {
          if (id !== rowId) {
            toggleRowSelected(id, false);
          }
        });
        toggleRowSelected(rowId, value);
      },
    },
    useSortBy,
    useRowSelect,
    useResizeColumns,
    useFlexLayout
  );

  useEffect(() => {
    if (onSelectRow) {
      const selectedRow = rows.find((row) => selectedRowIds[row.id]);
      onSelectRow(selectedRow ? selectedRow.original : null);
    }
  }, [selectedRowIds, onSelectRow, rows]);

  return (
    <fieldset className="full-height">
      <legend>{title}</legend>
      <div className="overflow-x-auto m-1 w-full border !border-black">
        <table
          {...getTableProps()}
          className="min-w-full table-auto border-collapse w-full"
        >
          <thead className="">
            {headerGroups.map((headerGroup, headerIndex) => (
              <tr {...headerGroup.getHeaderGroupProps()} className="">
                <td className="p-2 opacity-0">
                  <input type="radio" />
                </td>
                {headerGroup.headers.map((column, columnIndex) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={`p-2 text-left border-r !border-black ${
                      column.isSorted
                        ? column.isSortedDesc
                          ? "desc"
                          : "asc"
                        : ""
                    }`}
                    style={{ ...column.getHeaderProps().style }}
                  >
                    {column.render("Header").replace("__c", "")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                    <div {...column.getResizerProps()} className="resizer" />
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="">
            {rows.length > 0 ? (
              <>
                {rows.map((row, rowIndex) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className={`border-black hover:bg-[#3d3c3d] ${
                        row.isSelected ? "selected-color" : ""
                      }`}
                      onClick={() => {
                        toggleAllRowsSelected(false);
                        row.toggleRowSelected(!row.isSelected);
                      }}
                    >
                      <td className="p-2 border-t border-black">
                        <input
                          type="radio"
                          checked={row.isSelected}
                          onChange={() => {}}
                        />
                      </td>
                      {row.cells.map((cell, index) => (
                        <td
                          {...cell.getCellProps()}
                          className="p-2 border-t border-r border-black text-nowrap text-ellipsis overflow-hidden "
                        >
                          <abbr title={cell.value} className=" !no-underline">
                            {cell.render("Cell")}
                          </abbr>
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </>
            ) : (
              <p className="w-full text-center p-4">No data available</p>
            )}
          </tbody>
        </table>
      </div>
    </fieldset>
  );
};

export default DataTable;
